/**
 * 产品设计文档清单（源文件在仓库根目录，经 scripts/sync-design-docs.sh 同步到 api/design-docs/）
 * 仅管理员可通过 /api/v1/admin/design-doc/ 读取。
 */
export const DESIGN_DOCS = [
  {
    id: 'product',
    title: 'CoolPeople 产品设计',
    description: '平台总览、模块与接口说明',
    file: 'product-design.html'
  },
  {
    id: 'invite-referral',
    title: '邀请码与推荐券',
    description: '拉新、绑定、分润与后台配置',
    file: 'invite-referral-design.html'
  },
  {
    id: 'exam-json',
    title: '测评题目 JSON',
    description: '量表结构、计分与 feedbacks 规范',
    file: 'exam-json-design.html'
  },
  {
    id: 'oauth-email-log',
    title: '扫码登录与邮件日志',
    description: '微信扫码设密、一次性昵称、邮件投递审计',
    file: 'oauth-email-log-design.html'
  },
  {
    id: 'ai-followup-rag',
    title: 'AI 追问跳过 RAG',
    description: '会话问答判定追问/新问题，追问不再检索知识库',
    file: 'ai-followup-rag-design.html'
  },
  {
    id: 'avatar-audit',
    title: '用户头像审核与展示',
    description: '资料审核流程、存储规范与前端展示',
    file: 'avatar-audit-design.html'
  },
  {
    id: 'security',
    title: '安全审计报告',
    description: '漏洞与整改记录',
    file: 'security-report.html'
  },
  {
    id: 'business-loop-gaps',
    title: '业务闭环缺口报告',
    description: '用户端 / 管理端 / 站内信对照，复审后仍未闭环的项',
    file: 'business-loop-gaps.html'
  }
]

export function designDocApiUrl(filename) {
  return `/api/v1/admin/design-doc/${filename}`
}

export function findDesignDoc(id) {
  return DESIGN_DOCS.find((d) => d.id === id) || DESIGN_DOCS[0]
}
